// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1m-0";